import React, { useState } from 'react';

import { StandardButton } from '@eika/button';
import { Select } from '@eika/select';

import { StringKeyValue } from '../../actions/types';
import { LbsReducer } from '../../reducers/lbs';

interface Props {
    text: StringKeyValue;
    lbs: LbsReducer;
}

const LBSBankSelectComponent = (props: Props): JSX.Element => {
    const { text, lbs } = props;
    const [lbsBank, setLbsBank] = useState('1100');
    return (
        <>
            <p>{text.lbsBankSelectInfoTekst}</p>
            <Select
                name="bankChoice"
                label={text.lbsBankSelectDropdownLabel}
                values={lbs.lbsBanks}
                value={lbsBank}
                onChange={(e: any) => setLbsBank(e.target.value)}
            />
            <br />
            <StandardButton
                type="submit"
                onClick={() => {
                    const url = new URL(window.location.href);
                    url.hash = '';
                    url.searchParams.set('lbsbnr', lbsBank);
                    window.history.replaceState({}, '', url.toString());
                    window.location.reload();
                }}
            >
                {text.lbsBankSelectButtonText}
            </StandardButton>
        </>
    );
};

export default LBSBankSelectComponent;
